import React from 'react';
import styled from 'styled-components';
import FormInput from './common/FormInput';
import FormContainer from './common/FormContainer';
import FormRow from './common/FormRow';

const ConfirmButton = styled.button`
  width: 100%;
  background-color: ${props => props.theme.primary || '#e74c3c'};
  color: white;
  border: none;
  border-radius: 12px;
  padding: 1rem;
  margin-top: 1.5rem;
  cursor: pointer;
  font-weight: 700;
  font-size: 1rem;
  transition: all 0.2s;
  box-shadow: 0 4px 6px ${props => props.theme.primary ? `${props.theme.primary}33` : 'rgba(231, 76, 60, 0.2)'};

  &:hover {
    background-color: ${props => props.theme.secondary || '#c0392b'};
    transform: translateY(-1px);
    box-shadow: 0 6px 12px ${props => props.theme.primary ? `${props.theme.primary}4D` : 'rgba(231, 76, 60, 0.3)'};
  }

  &:active {
    transform: translateY(0);
  }
`;

interface Address {
  street: string;
  number: string;
  complement: string;
  neighborhood: string;
  city: string;
  state: string;
}

interface AddressFormModalProps {
  address: Address;
  onAddressChange: (field: string, value: string) => void;
  onSubmit: () => void;
}

const AddressFormModal: React.FC<AddressFormModalProps> = ({
  address,
  onAddressChange,
  onSubmit,
}) => {
  return (
    <FormContainer>
      <FormRow grid="2fr 1fr">
        <FormInput 
          label="Rua"
          type="text" 
          value={address.street}
          onChange={(e) => onAddressChange('street', e.target.value)}
          placeholder="Rua das Flores"
        />

        <FormInput 
          label="Número"
          type="text" 
          value={address.number}
          onChange={(e) => onAddressChange('number', e.target.value)}
          placeholder="123"
        />
      </FormRow>

      <FormRow>
        <FormInput 
          label="Complemento"
          type="text" 
          value={address.complement}
          onChange={(e) => onAddressChange('complement', e.target.value)}
          placeholder="Apto, Bloco, etc."
        />

        <FormInput 
          label="Bairro"
          type="text" 
          value={address.neighborhood}
          onChange={(e) => onAddressChange('neighborhood', e.target.value)}
          placeholder="Bairro"
        />
      </FormRow>

      <FormRow>
        <FormInput 
          label="Cidade"
          type="text" 
          value={address.city}
          onChange={(e) => onAddressChange('city', e.target.value)}
          placeholder="Cidade"
        />

        <FormInput 
          label="Estado"
          type="text" 
          value={address.state}
          onChange={(e) => onAddressChange('state', e.target.value)}
          placeholder="UF"
        />
      </FormRow>
      <ConfirmButton onClick={onSubmit}>
        Confirmar
      </ConfirmButton>
    </FormContainer>
  );
};

export default AddressFormModal;